import { render, staticRenderFns } from "./VerificationCode.vue?vue&type=template&id=186f1530&scoped=true&"
import script from "./VerificationCode.vue?vue&type=script&lang=js&"
export * from "./VerificationCode.vue?vue&type=script&lang=js&"
import style0 from "./VerificationCode.vue?vue&type=style&index=0&id=186f1530&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186f1530",
  null
  
)

export default component.exports